import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=2255d5dc&scoped=true"
import script from "./Box.vue?vue&type=script&lang=js"
export * from "./Box.vue?vue&type=script&lang=js"
import style0 from "./Box.vue?vue&type=style&index=0&id=2255d5dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2255d5dc",
  null
  
)

export default component.exports